import React, { useState, useEffect } from 'react';
import * as QueryString from 'query-string';
import ProjectQuestionnaireTemplateService from '../services/project_questionnaire_template.service';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'react-bootstrap';
import { DocumentTemplateSectionRow } from '@rd-web-markets/shared/dist/util/files';
import { QuestionnaireTemplateImportsService } from '../services/questionnaire_template_imports.service';
export default function ProjectQuestionnaireTemplatePage(_ref) {
  let {
    handleToaster,
    accountType
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [newProjectITtemplate, setNewProjectITtemplate] = useState(null);
  const [newProjectNonITtemplate, setNewProjectNonITtemplate] = useState(null);
  const [ongoingProjectITtemplate, setOngoingProjectITtemplate] = useState(null);
  const [ongoingProjectNonITtemplate, setOngoingProjectNonITtemplate] = useState(null);
  const [importStatuses, setImportStatuses, fetchAndSetImportStatuses] = QuestionnaireTemplateImportsService.useFetchImportStatuses({
    setLoading
  });
  const deleteQuestionnaireImportStatus = QuestionnaireTemplateImportsService.useDelete({
    setLoading,
    handleToaster,
    onSuccess: fetchAndSetImportStatuses
  });
  const {
    t
  } = useTranslation();
  const {
    download
  } = ProjectQuestionnaireTemplateService;
  const uploadQuestionnaireTemplate = ProjectQuestionnaireTemplateService.useUpload({
    setLoading,
    handleToaster
  });
  const onImportFile = (e, questionnaire_type) => {
    return uploadQuestionnaireTemplate({
      formDataJson: {
        file: e.target.files[0],
        questionnaire_type
      }
    });
  };
  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        await getTemplate('new_it_project_document', setNewProjectITtemplate);
        await getTemplate('new_non_it_project_document', setNewProjectNonITtemplate);
        await getTemplate('ongoing_it_project_document', setOngoingProjectITtemplate);
        await getTemplate('ongoing_non_it_project_document', setOngoingProjectNonITtemplate);
      } catch (error) {
        handleToaster('error', t('fetch_failed'));
      }
    };
    fetchTemplates();
  }, [download]);
  const getTemplate = async (questionnaire_type, setTemplate) => {
    setLoading(true);
    download(QueryString.stringify({
      questionnaire_type
    })).then(blob => {
      const url = URL.createObjectURL(blob);
      setTemplate({
        download_link: {
          url
        }
      });
      setLoading(false);
    }).catch(error => {
      console.error('Error fetching template document', error);
      setLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MasterSidebar, {
    accountType: accountType,
    currentPage: "project_questionnaire_templates"
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement("h4", null, t('project_questionnaire_template'))), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(DocumentTemplateSectionRow, {
    importStatuses: importStatuses.filter(im => im.questionnaire_template_type === 'new_it_project_document'),
    onUpload: onImportFile,
    title: t('new_project_it_questionnaire'),
    template: newProjectITtemplate,
    documentType: "new_it_project_document",
    loading: loading,
    onDelete: deleteQuestionnaireImportStatus
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(DocumentTemplateSectionRow, {
    importStatuses: importStatuses.filter(im => im.questionnaire_template_type === 'new_non_it_project_document'),
    onUpload: onImportFile,
    title: t('new_project_non_it_questionnaire'),
    template: newProjectNonITtemplate,
    documentType: "new_non_it_project_document",
    loading: loading,
    onDelete: deleteQuestionnaireImportStatus
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(DocumentTemplateSectionRow, {
    importStatuses: importStatuses.filter(im => im.questionnaire_template_type === 'ongoing_it_project_document'),
    onUpload: onImportFile,
    title: t('ongoing_project_it_questionnaire'),
    template: ongoingProjectITtemplate,
    documentType: "ongoing_it_project_document",
    loading: loading,
    onDelete: deleteQuestionnaireImportStatus
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(DocumentTemplateSectionRow, {
    importStatuses: importStatuses.filter(im => im.questionnaire_template_type === 'ongoing_non_it_project_document'),
    onUpload: onImportFile,
    title: t('ongoing_project_non_it_questionnaire'),
    template: ongoingProjectNonITtemplate,
    documentType: "ongoing_non_it_project_document",
    loading: loading,
    onDelete: deleteQuestionnaireImportStatus
  }))));
}